<template>
    <span class="d-flex align-center ga-1">
        <v-img v-if="flagSrc" :src="flagSrc" :alt="params.countryCode" width="20" height="20" cover />
        <span>{{ params.displayName }}</span>
    </span>
</template>

<script setup>
    import { computed } from 'vue';
    import flagDe from '@/assets/images/flags/de.png';
    import flagEn from '@/assets/images/flags/en.png';
    import flagEs from '@/assets/images/flags/es.png';
    import flagFr from '@/assets/images/flags/fr.png';
    import flagPt from '@/assets/images/flags/pt.png';
    import flagNl from '@/assets/images/flags/nl.png';

    const flags = { de: flagDe, en: flagEn, es: flagEs, fr: flagFr, pt: flagPt, nl: flagNl };

    const { params } = defineProps(['params']);

    const flagSrc = computed(() => {
        const countryCode = (params.countryCode || '').toLowerCase();

        return flags[countryCode] || null;
    });
</script>
